import type { ReactNode } from 'react'
import { GlobalSearch } from '~/components'
import { cn } from '~/utils'

type NextMapGlobalSearchProps = {
  className?: string
  collapseTrigger?: (openSearch: () => void) => ReactNode
  onPlaceSelect?: (place: { lng: number; lat: number; zoom: number }) => void
}

export function NextMapGlobalSearch({
  className,
  collapseTrigger,
  onPlaceSelect,
}: NextMapGlobalSearchProps) {
  return (
    <GlobalSearch
      className={cn('w-42 overflow-hidden rounded-md shadow-none', className)}
      collapseInput={true}
      collapseTrigger={collapseTrigger}
      onPlaceSelect={onPlaceSelect}
    />
  )
}
